import React from "react";

import "./QrCodeDisplay.scss";
import { QRCodeSVG } from "qrcode.react";

export default function QrCodeDisplay({ value, width, onCodeClick }) {

	const on_click = () => {
		onCodeClick?.();
	}

	return (
		<div className="qr-code-display">
			<div className="qr-holder" onClick={on_click}>
				<QRCodeSVG value={value} size={width ?? 250} />
			</div>
		</div>
	);
}